import { Datasets } from "../../components/Dataset/Dataset";
import "react-dropdown/style.css";
import "../../styles/AcquisitionDataPage.css";
import "../../styles/org-buttons.css";
import "../../styles/DatasetPage.css";
import Modal from "react-modal";
import NavigationBar from "../../components/NavBar/NavBar";
import DatasetWorkspaceShell from "../../components/Dataset/DatasetWorkspaceShell";
import CustomizedContent from "./CustomizedContent";
import { Tabs, Tab } from "react-bootstrap";
import { Folders } from "../../components/Folder/Folder";
import {
  useDataContext,
  AcquisitionDataProvider,
} from "../../utils/DataContext";
import Tables from "../../components/Table/Table";
import { getUserCookie } from "../../utils/cookiesUtils";

Modal.setAppElement("#root");

function AcquisitionDataPage() {
  return (
    <AcquisitionDataProvider>
      <AcquisitionDataPageChild />
    </AcquisitionDataProvider>
  );
}

function AcquisitionDataPageChild() {
  const { availSpace } = useDataContext();

  const userData = getUserCookie();
  const role = userData ? userData.role : null;

  let display = (
    <Datasets
      CustomizedContent={CustomizedContent}
      overviewTitle="Data Acquisition"
      overviewDescription="Manage datasets for acquisition, upload, and workspace ingestion workflows."
    />
  );
  // if (role !== "annotator") {
  //   display = (
  //     <Tabs defaultActiveKey="acquisition-data-dataset">
  //     <Tab eventKey="acquisition-data-dataset" title="Datasets">
  //       <Datasets CustomizedContent={CustomizedContent} />
  //     </Tab>
  //     <Tab eventKey="acquisition-data-folder" title="Folders">
  //       <Folders />
  //     </Tab>
  //     <Tab eventKey="acquisition-data-table" title="Tables">
  //       <Tables />
  //     </Tab>
  //   </Tabs>
  //   );
  // }

  return (
    <div className="acquisition-data-page">
      <NavigationBar />
      <DatasetWorkspaceShell
        mainClassName="acquisition-data-main"
        storageLabel={role === "admin" ? "Storage Available" : null}
        storageValue={role === "admin" ? availSpace : null}
      >
        {display}
      </DatasetWorkspaceShell>
    </div>
  );
}

export default AcquisitionDataPage;
